<template>
  <section>
    <div class="container-fluid">
      <uspCartao titulo="Configurações" :fechavel="false">
        <template slot="corpo">
          <uspAcordeao :itens="itens"></uspAcordeao>
        </template>
      </uspCartao>
    </div>
  </section>
</template>

<script>
import AlterarSenha from '../components/configuracoes/AlterarSenha.vue';
import AlterarEmail from '../components/configuracoes/AlterarEmail.vue';

export default {
  name: 'Configuracoes',

  data(){
    return{

    itens: [
      {
        titulo: "Alterar senha",
        nome: "AlterarSenha",
        componente: AlterarSenha,
      },
      {
        titulo: "Alterar E-mail",
        nome: "AlterarEmail",
        componente: AlterarEmail,
      }
    ],
  }
  },
}
</script>

<style>
.regras {
  list-style: none;
}

.regras .header {
  text-transform: uppercase;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.valido {
  color: green;
}

.invalido {
  color: red;
}
</style>
